import { z } from 'zod';
export const GuideRole = z.enum(['user', 'assistant']);
export const GuideMessage = z.object({
    id: z.number().int(),
    role: GuideRole,
    paragraphs: z.array(z.string()),
    created_at: z.string(),
});
export const GuideMessagesResponse = z.object({
    messages: z.array(GuideMessage),
});
export const AskGuideRequest = z.object({
    text: z.string().min(1).max(2000),
    year: z.number().int().min(1900).max(2200),
    month: z.number().int().min(0).max(11),
});
export const AskGuideResponse = z.object({
    paragraphs: z.array(z.string().min(1)),
});
